module.exports = __webpack_public_path__ + "static/media/ic-bookmark-active.63d6e29c.svg";